import {copyObj}        from '../../util';

export default {
    inject : ['gridInfo'],
    data() {return {
        refCellMap : new Map(),
    }},
    props : {
        row : {type:Object},
        idx : {type:Number},
        groupHeight : {type:Array},
    },
    computed: {
        // [COMPUTED] Etc values...
        isEditOther() {return !!this.gridInfo.vars_currEditRow},
        // [COMPUTED] Maybe common style.
        rowClass() {
            var clazz = [];
            // 1. simple flags.
            if(this.row.__selected){clazz.push('ur-data-grid__content__row--selected')}
            if(this.row.__focused) {clazz.push('ur-data-grid__content__row--focused')}
            if(this.row.__hover)   {clazz.push('ur-data-grid__content__row--hover')}
            if(this.row.__active)   {clazz.push('ur-data-grid__content__row--active')}
            // 2. dirty
            if(this.row.__dirty)         {clazz.push('ur-data-grid__content__row--dirty')}
            if(this.row.__dirty === 'U') {clazz.push('ur-data-grid__content__row--dirty--updated')}
            if(this.row.__dirty === 'C') {clazz.push('ur-data-grid__content__row--dirty--created')}
            if(this.row.__dirty === 'D') {clazz.push('ur-data-grid__content__row--dirty--removed')}
            
            return clazz
        },
        // [COMPUTED] Shared data
        sharedData() {
            let rtn = {}, odf = Object.defineProperty;
            odf(rtn, 'row'        , {get:()=>this.row});
            odf(rtn, 'idx'        , {get:()=>this.idx});
            odf(rtn, 'groupHeight', {get:()=>this.groupHeight});
            return rtn;
        },
    },
    mounted() {
        this.refCellMap.clear();
        if(this.$refs.cells) {// EXCEPTION -> If all fields is freeze? -> no cells for scroll area
            this.$refs.cells.forEach(cell => {
                this.refCellMap.set(cell.field.value, cell)
            })
        }
    },
    methods : {
        onDblClick(e) {
            this.gridInfo.func.fireEvent('row-dbl-click',this.row, e)
        },
        // [METHODS] Event, for click row
        onRowClick(e) {
            // 1. row Edit 관련
            if(this.row.__editMode) {
                // 1.1 If I'm on edit mode and Click myself?
                return
            } else if(this.isEditOther) {
                return;
            }
            // 1.2 cancel previous edit
            
            // 2. Focus action
            if(this.gridInfo.opts.focusOn) {
                this.gridInfo.func.setFocus(this.row);
            }

            // 3. Select action
            if(!this.gridInfo.opts.selectCheckOnly) {
                // 3.1 click mode : default
                if( this.gridInfo.opts.clickMode === 'default') {
                    this.gridInfo.func.setSelect(this.row);
                }
                // 3.2 click mode : functional
                else if( this.gridInfo.opts.clickMode === 'functional') {
                    var shift = e.shiftKey, ctrl = e.ctrlKey;
                    if(shift && ctrl) {
                        this.gridInfo.func.setRangeSelect(this.row, true);
                    } else if(shift) {
                        this.gridInfo.func.setRangeSelect(this.row, false);
                    } else if(ctrl) {
                        this.gridInfo.func.setSelect(this.row);
                    } else { // normal click
                        this.gridInfo.func.setSelect(this.row, false);
                    }
                }
                // 3.3 and prevent select text
                if(e.shiftKey) { // "FOR IE", shift click -> bypass user-select:none
                    e.preventDefault();
                    window.getSelection().removeAllRanges(); 
                }


            }

            //4. clicked
            if(this.gridInfo.opts.activeOn){
                this.setClicked(true, e);
            }
            
            // x. fire grid event
            this.gridInfo.func.fireEvent('row-click',this.row, e)
        },
        // [METHODS] Event, for hover & leave row
        setHover(flag,e) {
            // x. check cell-Select : onDrag
            if(this.gridInfo.vars_cSelOnDrag) {flag=false;}
            // 1. set flag to row
            this.gridInfo.func.setRowValue(this.row, '__hover', flag)
        },
        setClicked(flag, e){
            // 1. set flag to row
            if(this.gridInfo.opts.activeOn) {
                this.gridInfo.func.setRowValue(this.row, '__active', flag)
            }

        },
        onMouseLeave(e){
            this.setHover(false,e);
            this.setClicked(false, e)
        },
        onMouseUp(e){
            this.setClicked(false, e)
        },
        onMouseMove(e){
            e.preventDefault();
        },
        // [METHOD] Util, Open & Close accordion area
        toggleAccordion(v) {
            this.gridInfo.func.openAccordion(this.row, v)
        },
        // [METHOD] Util, Focus first cell which is editable
        focusFirst() {
            this.$refs.cells.find(c=>{
                return c.focus()
            })
        }
    },
    provide() {
        return {rowInfo:this.sharedData};
    }
}